import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ContentComponent } from './components/layout/content/content.component';
import { FullComponent } from './components/layout/full/full.component';
import { ClickOutSideDirective } from './directives/click-out-side.directive';
import { DisableKeyPressDirective } from './directives/disable-key-press.directive';
import { OnlyAlphabetsDirective } from './directives/only-alphabets.directive';
import { OnlyEnglishAlphabetsDirective } from './directives/only-english-alphabets.directive';
import { OnlyArabicAlphabetsDirective } from './directives/only-arabic-alphabets.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { ShortingDirective } from './directives/shorting.directive';
import { ShowOptionsDirective } from './directives/show-options.directive';
import { NgbdSortableHeaderDirective } from './directives/ngbd-sortable-header.directive';

import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
// import { DragulaModule } from "ng2-dragula";
import { TranslateModule } from "@ngx-translate/core";

import { CarouselModule } from "ngx-owl-carousel-o";
import { LayoutService } from './services/layout.service';
import { NavService } from './services/nav.service';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { SearchComponent } from './components/header/elements/search/search.component';
import { LanguagesComponent } from './components/header/elements/languages/languages.component';
import { NotificationComponent } from './components/header/elements/notification/notification.component';
import { MyAccountComponent } from './components/header/elements/my-account/my-account.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestHeadersInterceptor } from './interceptors/request-headers.interceptor';
import { InputErrorComponent } from './components/input-error/input-error.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DropdownModule } from 'primeng/dropdown';
import { SliderModule } from 'primeng/slider';
import { TreeModule } from 'primeng/tree';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonModule } from 'primeng/button';
import { FullCalendarModule } from '@fullcalendar/angular';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NoLeadingZeroDirective } from './directives/no-leading-zero.directive';
import { MaxDigitDirective } from './directives/max-digit.directive';
import { StartPhoneFiveDirective } from './directives/start-phone-five.directive';
import { CreditInputDirective } from './directives/credit-input.directive';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { TermsAndConditionsToReadComponent } from './components/terms-and-conditions/terms-and-conditions-to-read/terms-and-conditions-to-read.component';
import { SimplePieChartComponent } from './components/dashboard/simple-pie-chart/simple-pie-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { StartNationalIdOneDirective } from './directives/start-national-id-one.directive';
import { StartNationalIdTwoDirective } from './directives/start-national-id-two.directive';
import { ChildStatusComponent } from './components/dashboard/child-status/child-status.component';
import { BasicAreaChartComponent } from './components/dashboard/basic-area-chart/basic-area-chart.component';
import { MultiSelectModule } from 'primeng/multiselect';


@NgModule({
  declarations: [
    BreadcrumbComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    SidebarComponent,
    ContentComponent,
    FullComponent,
    FeatherIconsComponent,
    SearchComponent,
    // MegaMenuComponent,
    LanguagesComponent,
    NotificationComponent,
    MyAccountComponent,
    SvgIconComponent,
    ClickOutSideDirective,
    DisableKeyPressDirective,
    OnlyAlphabetsDirective,
    OnlyEnglishAlphabetsDirective,
    OnlyArabicAlphabetsDirective,
    OnlyNumbersDirective,
    ShortingDirective,
    ShowOptionsDirective,
    NgbdSortableHeaderDirective,
    InputErrorComponent,
    NoLeadingZeroDirective,
    MaxDigitDirective,
    StartPhoneFiveDirective,
    CreditInputDirective,
    TermsAndConditionsComponent,
    TermsAndConditionsToReadComponent,
    SimplePieChartComponent,
    StartNationalIdOneDirective,
    StartNationalIdTwoDirective,
    ChildStatusComponent,
    BasicAreaChartComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    TranslateModule,
    CarouselModule,
    BsDatepickerModule,
    TimepickerModule,
    OrganizationChartModule,
    ModalModule.forRoot(),
    NgSelectModule,
    AngularEditorModule,
    DropdownModule,
    SliderModule,
    TreeModule,
    StepsModule,
    TooltipModule,
    ButtonModule,
    FullCalendarModule,
    PaginationModule,
    CollapseModule,
    TableModule,
    NgApexchartsModule,
    MultiSelectModule,
  ],
  providers: [
    NavService,
    LayoutService,
    DecimalPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestHeadersInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ],
  exports: [
    NgbModule, 
    FormsModule, 
    ReactiveFormsModule,
    TranslateModule,
    BsDatepickerModule,
    TimepickerModule,
    LoaderComponent, 
    BreadcrumbComponent, 
    FeatherIconsComponent,
    SvgIconComponent,
    InputErrorComponent,
    DisableKeyPressDirective, 
    OnlyAlphabetsDirective,
    OnlyEnglishAlphabetsDirective, 
    OnlyArabicAlphabetsDirective,
    OnlyNumbersDirective,
    NoLeadingZeroDirective,
    MaxDigitDirective,
    CreditInputDirective,
    StartPhoneFiveDirective,
    NgxSpinnerModule,
    OrganizationChartModule,
    ModalModule,
    NgSelectModule,
    AngularEditorModule,
    DropdownModule,
    SliderModule,
    TreeModule,
    StepsModule,
    TooltipModule,
    ButtonModule,
    FullCalendarModule,
    PaginationModule,
    CollapseModule,
    TableModule,
    NgApexchartsModule,
    SimplePieChartComponent,
    StartNationalIdOneDirective,
    StartNationalIdTwoDirective,
    ChildStatusComponent,
    BasicAreaChartComponent,
    MultiSelectModule,
  ],
})
export class SharedModule { }
